module.exports = publishpressFutureQuickEditConfig;